const inputIndex = [1, 2, 3, 4, 5, 6, 10, 13, 14, 15, 16, 17, 18, 22, 25, 26, 27, 28, 29, 30, 34, 37, 38, 39, 40, 41, 42, 46, 53, 54];

const numConvert = (num = 0) => {
    num = Number(num || "0")
    return num
};

const getJson = (arr, obj, value = 0) => {
    return arr.reduce((a, b) => a && a[b] ? a[b] : value, obj)
}

const computeNum = (data, dataTitle = []) => {
    const listName = ['shop', 'Chinese', 'Thai', 'banquet', 'lounge', 'stewarding', 'others'];
    // total计算
    inputIndex.forEach(i => {
        data[i].total = listName.reduce((a, b) => {
            a += numConvert(data[i][b]);
            return a
        }, 0).toFixed(2)
    });
    ['total', ...listName, 'last', 'rooms', 'last_total'].forEach(name => {
        data[7][name] = (numConvert(data[1][name]) + numConvert(data[2][name]) + numConvert(data[3][name]) - numConvert(data[4][name]) - numConvert(data[5][name]) - numConvert(data[6][name])).toFixed(2);
        data[8][name] = ((numConvert(data[1][name]) + numConvert(data[6][name])) == 0 ? 0 : numConvert(data[7][name]) / ((numConvert(data[1][name]) + numConvert(data[6][name])) / 2)).toFixed(4);
        data[9][name] = (numConvert(data[7].total) == 0 ? 0 : numConvert(data[7][name]) / numConvert(data[7].total)).toFixed(4);
        data[11][name] = (numConvert(data[7][name]) - numConvert(data[10][name])).toFixed(2);

        data[19][name] = (numConvert(data[13][name]) + numConvert(data[14][name]) + numConvert(data[15][name]) - numConvert(data[16][name]) - numConvert(data[17][name]) - numConvert(data[18][name])).toFixed(2);
        data[20][name] = ((numConvert(data[13][name]) + numConvert(data[18][name])) == 0 ? 0 : numConvert(data[19][name]) / ((numConvert(data[13][name]) + numConvert(data[18][name])) / 2)).toFixed(4);
        data[21][name] = (numConvert(data[19].total) == 0 ? 0 : numConvert(data[19][name]) / numConvert(data[19].total)).toFixed(4);
        data[23][name] = (numConvert(data[19][name]) - numConvert(data[22][name])).toFixed(2);

        data[31][name] = (numConvert(data[25][name]) + numConvert(data[26][name]) + numConvert(data[27][name]) - numConvert(data[28][name]) - numConvert(data[29][name]) - numConvert(data[30][name])).toFixed(2);
        data[32][name] = ((numConvert(data[25][name]) + numConvert(data[30][name])) == 0 ? 0 : numConvert(data[31][name]) / ((numConvert(data[25][name]) + numConvert(data[30][name])) / 2)).toFixed(4);
        data[33][name] = (numConvert(data[31].total) == 0 ? 0 : numConvert(data[31][name]) / numConvert(data[31].total)).toFixed(4);
        data[35][name] = (numConvert(data[31][name]) - numConvert(data[34][name])).toFixed(2);

        data[43][name] = (numConvert(data[37][name]) + numConvert(data[38][name]) + numConvert(data[39][name]) - numConvert(data[40][name]) - numConvert(data[41][name]) - numConvert(data[42][name])).toFixed(2);
        data[44][name] = ((numConvert(data[37][name]) + numConvert(data[42][name])) == 0 ? 0 : numConvert(data[43][name]) / ((numConvert(data[37][name]) + numConvert(data[42][name])) / 2)).toFixed(4);
        data[45][name] = (numConvert(data[43].total) == 0 ? 0 : numConvert(data[43][name]) / numConvert(data[43].total)).toFixed(4);
        data[47][name] = (numConvert(data[43][name]) - numConvert(data[46][name])).toFixed(2);

        data[48][name] = (numConvert(data[7][name]) + numConvert(data[19][name]) + numConvert(data[31][name]) + numConvert(data[43][name])).toFixed(2);

        const Denominator = ((numConvert(data[1][name]) + numConvert(data[6][name])) / 2) + ((numConvert(data[13][name]) + numConvert(data[18][name])) / 2) + ((numConvert(data[25][name]) + numConvert(data[30][name])) / 2) + ((numConvert(data[37][name]) + numConvert(data[42][name])) / 2);
        data[49][name] = (Denominator == 0 ? 0 : numConvert(data[48][name]) / Denominator).toFixed(4);
        data[50][name] = (numConvert(data[48].total) == 0 ? 0 : numConvert(data[48][name]) / numConvert(data[48].total)).toFixed(4);
        data[51][name] = (numConvert(data[10][name]) + numConvert(data[22][name]) + numConvert(data[34][name]) + numConvert(data[46][name])).toFixed(2);
        data[52][name] = (numConvert(data[11][name]) + numConvert(data[23][name]) + numConvert(data[35][name]) + numConvert(data[47][name])).toFixed(2);
        data[55][name] = (numConvert(data[53][name]) == 0 ? 0 : numConvert(data[48][name]) / numConvert(data[53][name])).toFixed(2);
        data[55][name] = (numConvert(data[53][name]) == 0 ? 0 : numConvert(data[48][name]) / numConvert(data[53][name])).toFixed(2);
        data[56][name] = (getJson([0, 'day'], dataTitle) == 0 ? 0 : data[48][name] / getJson([0, 'day'], dataTitle)).toFixed(2);
        data[57][name] = (numConvert(data[54][name]) == 0 ? 0 : numConvert(data[51][name]) / numConvert(data[54][name])).toFixed(4);
        data[58][name] = (numConvert(data[54][name]) == 0 ? 0 : numConvert(data[52][name]) / numConvert(data[54][name])).toFixed(4);
        [7, 19, 31, 43, 48, 53, 54].forEach(i => {
            data[i].var = (numConvert(data[i].last) == 0 ? 0 : (numConvert(data[i].total) - numConvert(data[i].last)) / numConvert(data[i].last)).toFixed(4);
            data[i].last_var = (numConvert(data[i].last_total) == 0 ? 0 : (numConvert(data[i].rooms) - numConvert(data[i].last_total)) / numConvert(data[i].last_total)).toFixed(4);
        });

        [8, 20, 32, 44, 49, 55, 56, 57, 58].forEach(i => {
            data[i].var = (numConvert(data[i].total) - numConvert(data[i].last)).toFixed(4);
            data[i].last_var = (numConvert(data[i].rooms) - numConvert(data[i].last_total)).toFixed(4);
        })

    });
    return data
}

export default computeNum;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-4/compute.js